module.exports = __webpack_public_path__ + "static/media/cry.0ea19ec1.png";